import React, { Component } from 'react';
import { Route, Switch } from "react-router-dom";
import './App.css';
import BookPicker from './components/BookPicker';
import NavigationBar from './components/NavigationBar';
import ResultPage from './components/ResultPage';
class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      showResults: false,
      recommendations: [],
      user: {},
      renderOnce: true,
    }
    this.getIp();
  }

  getIp = () => {
    fetch('https://json.geoiplookup.io')
    .then(res => res.json())
    .then(json => this.setState({user: json}))
  }
  
  getResults = (results) => {
    // console.log(results);
    this.setState({ showResults: true, recommendations: results});
  }

  backToFirstPage = () => {
    this.setState({ showResults: false, recommendations: []});
  }

  renderUI = () => {
    if (this.state.showResults) {
      return <ResultPage backToFirstPage={this.backToFirstPage} recommendations={this.state.recommendations}/>
    } else {
      return <BookPicker getResults={this.getResults} user={this.state.user}/>
    }
  }

  render() {
    return (
      <div className="App">
        <NavigationBar />
        <Switch>

          <Route 
            exact path="/" 
            render={(props) => <BookPicker {...props} getResults={this.getResults} user={this.state.user}/>} 
          />

          <Route 
            path="/results" 
            render={(props) => <ResultPage {...props} backToFirstPage={this.backToFirstPage} recommendations={this.state.recommendations}/>} 
          />

        </Switch>
        {/* {this.renderUI()} */}
        <div className="AppFooter"><span className='createdby'>Created by Christopher Harju - RecommendMeFantasyBooks@gmail.com ©</span></div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js